import {useEffect, useState} from "react";
import axios from "axios";
import {GET_ALL_TAMPONI_URL, GET_INFO_TAMPONI_URL} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {setZeroHoursToDate} from "../../../../utils/GenericUtils";

export default function useGetAllTamponi(stato, filters, pageNumber, testTipoDesc, sort, dir, irreperibili, dataEsito = null) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [tamponi, setTamponi] = useState([]);
	const [info, setInfo] = useState("");
	const [hasMore, setHasMore] = useState(false);
	
	function getData(stato, filters, testTipoDesc, irreperibili, dataEsito) {
		if (filters === "" && stato === "In gestione") {
			return {
				testTipoDesc: testTipoDesc === "tutti" ? null : testTipoDesc,
				active: true,
				dataEsito: setZeroHoursToDate(dataEsito),
			}
		}
		if (filters === "" && stato === "Da gestire") {
			return {
				testTipoDesc: testTipoDesc === "tutti" ? null : testTipoDesc,
				stato: "Da gestire",
				active: false,
				comunicazioni: irreperibili ? irreperibili : null,
				esitoTampone: filters ? filters : null,
				dataEsito: setZeroHoursToDate(dataEsito),
			}
		}
		return {
			testTipoDesc: testTipoDesc === "tutti" ? null : testTipoDesc,
			stato: stato,
			active: null,
			comunicazioni: irreperibili ? irreperibili : null,
			esitoTampone: filters ? filters : null,
			dataEsito: setZeroHoursToDate(dataEsito),
		}
	}
	
	useEffect(() => {
		setTamponi([]);
	}, [stato, filters, testTipoDesc, sort, dir, irreperibili, dataEsito])
	
	useEffect(() => {
		axios({
			method: "POST",
			url: GET_INFO_TAMPONI_URL,
			data: getData(stato, filters, testTipoDesc, irreperibili),
			...getConfig()
		})
			.then(response => setInfo(response.data))
	}, [stato, filters, testTipoDesc, irreperibili])
	
	useEffect(() => {
		setLoading(true);
		setError(false);
		axios({
			method: "POST",
			url: GET_ALL_TAMPONI_URL + pageNumber + "/" + sort + "/" + dir,
			data: getData(stato, filters, testTipoDesc, irreperibili, dataEsito),
			...getConfig(),
		}).then(response => {
			setTamponi(prevState => {
				let newState = [...prevState, ...response.data];
				return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
			})
			setHasMore(response.data.length > 0);
			setLoading(false);
		}).catch(() => {
			setError(true);
			setLoading(false);
		})
		
	}, [stato, pageNumber, filters, testTipoDesc, sort, dir, irreperibili, dataEsito])
	
	return {loading, error, tamponi, hasMore, info};
}
